const getBorderStyle = (state) => { return state.draft.borderStyle }
const getColorStyle = (state) => { return state.draft.colorStyle }
const getLabelStyle = (state) => { return state.draft.labelStyle }
const getMarkerColor = (state) => { return state.markerStyle.iconColor }
const getMarkerIcon = (state) => { return state.markerStyle.iconImage }
const getMarkerSize = (state) => { return state.markerStyle.iconSize }
const getSizeStyle = (state) => { return state.draft.sizeStyle }
const getSymbolStyle = (state) => { return state.draft.symbolStyle }

export default {
  getBorderStyle,
  getColorStyle,
  getLabelStyle,
  getMarkerColor,
  getMarkerIcon,
  getMarkerSize,
  getSizeStyle,
  getSymbolStyle
}
